import { useState } from 'react';
import { Link } from 'react-router-dom';
import VideoCard from '@/components/base/VideoCard';
import { videoItems } from '@/mocks/videos';

const tabs = [
  { key: 'all', label: '全部' },
  { key: 'movie', label: '影视' },
  { key: 'short', label: '短视频' },
  { key: 'live', label: '直播' },
];

export default function HotToday() {
  const [tab, setTab] = useState('all');

  const list = tab === 'all' ? videoItems : videoItems.filter((v) => v.categorySlug === tab);
  const display = list.slice(0, 8);

  return (
    <section className="mx-auto w-full px-4 md:px-6">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-fire-line text-lg" />
            </span>
            <h2 className="font-heading text-xl font-bold text-foreground-900 md:text-2xl">今日热门内容推荐</h2>
          </div>
          <p className="mt-2 text-sm text-foreground-500">根据观看热度与口碑实时聚合的精选内容</p>
        </div>

        <div className="flex items-center gap-1 rounded-full bg-background-200/70 p-1">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={`whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium transition-colors ${
                tab === t.key
                  ? 'bg-background-50 text-primary-600 shadow-sm'
                  : 'text-foreground-500 hover:text-foreground-800'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {display.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
          <i className="ri-inbox-line text-3xl text-foreground-300" />
          <p className="mt-3 text-sm text-foreground-500">暂无推荐内容，敬请期待</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {display.map((item) => (
            <VideoCard key={item.id} item={item} />
          ))}
        </div>
      )}

      <div className="mt-8 flex justify-center">
        <Link
          to="/category/movie"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          查看更多内容
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}